<template>
  <v-app id="inspire" :class="{ horizontalstyle: setHorizontalLayout }">
    <!-- ---------------------------------- -->
    <!--- Vertical Header part -->
    <!-- ---------------------------------- -->
    <VerticalHeader
      v-if="!setHorizontalLayout"
      v-model="expandOnHover"
    ></VerticalHeader>
    <!-- ---------------------------------- -->
    <!--- Horizontal Header part -->
    <!-- ---------------------------------- -->
    <HorizontalHeader v-else></HorizontalHeader>

    <v-main>
      <v-container fluid class="page-wrapper">
        <router-view />
      </v-container>
    </v-main>
    <!-- ---------------------------------- -->
    <!--- Vertical Sidebar  part -->
    <!-- ---------------------------------- -->
    <VerticalSidebar
      v-if="!setHorizontalLayout"
      :expand-on-hover.sync="expandOnHover"
    ></VerticalSidebar>
    <!-- ---------------------------------- -->
    <!--- Horizontal Sidebar part -->
    <!-- ---------------------------------- -->
    <HorizontalSidebar v-else></HorizontalSidebar>
    <!-- ---------------------------------- -->
    <!--- Vertical Footer part -->
    <!-- ---------------------------------- -->
    <Footer v-if="!setHorizontalLayout"></Footer>
    <!-- ---------------------------------- -->
    <!--- Horizontal Footer part -->
    <!-- ---------------------------------- -->
    <HorizontalFooter v-else></HorizontalFooter>
  </v-app>
</template>

<script>
import HorizontalHeader from "./horizontal-header/HorizontalHeader";
import VerticalHeader from "./vertical-header/VerticalHeader";
import HorizontalSidebar from "./horizontal-sidebar/HorizontalSidebar";
import VerticalSidebar from "./vertical-sidebar/VerticalSidebar";
import Footer from "./footer/Footer";
import HorizontalFooter from "./horizontal-footer/HorizontalFooter";
import { mapState } from "vuex";
export default {
  name: "Layout",

  components: {
    HorizontalHeader,
    VerticalHeader,
    HorizontalSidebar,
    VerticalSidebar,
    Footer,
    HorizontalFooter,
  },

  props: {
    source: String,
  },
  data: () => ({
    expandOnHover: false,
  }),
  computed: {
    ...mapState({
      connected: state => state.ethers.connected,
      setHorizontalLayout: state => state.setHorizontalLayout
    }),
  },
  mounted: function () {
    if (!this.connected) {
      this.$store.dispatch("ethers/init");
    }
  }
};
</script>

<style>
</style>